import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import client, { formatApiError } from "@/lib/api";
import { StatusBadge, DemoBadge } from "@/components/billing/StatusBadge";
import { inputCls, fmtDate } from "@/components/billing/shared";

// USDT billing, promo grants and internal notes for one member (admin member detail).
export function MemberBilling({ uid }) {
  const [d, setD] = useState(null);
  const [products, setProducts] = useState([]);
  const [promo, setPromo] = useState({ product_id: "", days: 30, reason: "" });
  const [note, setNote] = useState("");
  const load = () => client.get(`/admin/billing/members/${uid}`).then((r) => setD(r.data)).catch(() => setD(null));
  useEffect(() => { load(); client.get("/admin/billing/products").then((r) => setProducts(r.data)).catch(() => {}); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);
  if (!d) return null;
  const grant = async () => {
    try { await client.post("/admin/billing/promotions", { ...promo, user_id: uid, days: Number(promo.days) }); toast.success("Promotional access granted"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const addNote = async () => { await client.post(`/admin/members/${uid}/notes`, { text: note }); setNote(""); load(); };
  return (
    <div className="mt-6 space-y-5" data-testid="member-billing">
      <p className="text-[11px] font-mono-cl uppercase tracking-[0.16em] text-[#ccff00]">USDT billing</p>
      <div className="grid grid-cols-3 gap-2 text-sm">
        <div><p className="text-zinc-500 text-xs">Lifetime</p><b data-testid="member-lifetime">${d.lifetime_usd}</b></div>
        <div><p className="text-zinc-500 text-xs">Last payment</p>{fmtDate(d.last_payment_at)}</div>
        <div><p className="text-zinc-500 text-xs">Renewals</p>{d.renewals}</div>
      </div>
      {d.subscriptions.map((s) => <p key={s.id} className="text-sm">{s.product_name} · {s.source} · <StatusBadge status={s.status} /> · until {fmtDate(s.expires_at)}</p>)}
      {d.orders.slice(0, 10).map((o) => <p key={o.id} className="text-xs text-zinc-400">{fmtDate(o.created_at)} · {o.product_snapshot.name} · ${o.price_usd} · {o.status} {o.is_demo && <DemoBadge />}</p>)}
      <div className="rounded-xl border border-white/10 p-3 space-y-2">
        <p className="text-xs font-semibold">Grant promotional access (separate from paid records)</p>
        <select data-testid="promo-product" className={inputCls + " w-full"} value={promo.product_id} onChange={(e) => setPromo({ ...promo, product_id: e.target.value })}>
          <option value="">Choose product</option>{products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select>
        <div className="flex gap-2">
          <input data-testid="promo-days" type="number" className={inputCls + " w-24"} value={promo.days} onChange={(e) => setPromo({ ...promo, days: e.target.value })} />
          <input data-testid="promo-reason" className={inputCls + " flex-1"} placeholder="Reason" value={promo.reason} onChange={(e) => setPromo({ ...promo, reason: e.target.value })} />
        </div>
        <button data-testid="promo-grant" onClick={grant} disabled={!promo.product_id || promo.reason.length < 3} className="px-4 py-1.5 rounded-full bg-[#ccff00] text-black text-xs font-semibold disabled:opacity-40">Grant</button>
        {d.promos.map((p) => <p key={p.id} className="text-[11px] text-zinc-500">{fmtDate(p.created_at)} · {p.days}d · {p.reason}</p>)}
      </div>
      <div className="space-y-2">
        <p className="text-xs font-semibold">Internal notes</p>
        <div className="flex gap-2"><input data-testid="note-input" className={inputCls + " flex-1"} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Add a note (staff only)" />
          <button data-testid="note-add" disabled={!note.trim()} onClick={addNote} className="px-4 rounded-full border border-white/15 text-xs disabled:opacity-40">Add</button></div>
        {d.notes.map((n) => <p key={n.id} className="text-xs text-zinc-400">{fmtDate(n.created_at)} · {n.author}: {n.text}</p>)}
      </div>
    </div>
  );
}
